import type { GetUserRoles } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { updateRolesKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useResolveUpdateRoles(targetUserId?: string) {
  return useQuery({
    queryFn: () =>
      apiClient
        .url(`/users/update/resolve-roles`)
        .query(targetUserId ? { targetUserId } : {})
        .get()
        .json<GetUserRoles>(),
    queryKey: updateRolesKeys.byTargetUserId(targetUserId),
  });
}
